import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService, NotificationItem } from '../notifications/notification.service';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  isLoggedIn = false;
  notifications: NotificationItem[] = [];
  successMsg = '';
  isMenuOpen = false;

  constructor(private router: Router, private notificationService: NotificationService, private authService: AuthService) {}

  ngOnInit(): void {
    this.isLoggedIn = this.authService.isLoggedIn;
    this.authService.isLoggedIn$.subscribe(v => this.isLoggedIn = v);
    this.notificationService.notifications$.subscribe(arr => this.notifications = arr);
  }

  logout(): void {
    sessionStorage.removeItem('token1');
    this.authService.setLoggedIn(false);
    this.successMsg = 'You have been logged out.';
    this.router.navigate(['/login']);
    setTimeout(() => this.successMsg = '', 3000);
  }

  clearNotifications(): void {
    this.notificationService.clear();
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
  }
}


